import { Component, Input, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { AuthService } from '../../../../../../services/auth.service';
import { Subscription } from 'rxjs';
import { tap, filter, map, debounceTime } from 'rxjs/operators';
import { FormPackage } from '../models/df-package';
import { ComponentService, CreatorFrontApi } from '../../../../../../services/component.service';
import { DynamicFormPackageControlService } from '../services/df-package-control.service';

@Component({
	selector: 'dynamic-form',
	templateUrl: './dynamic-form.component.html',
	styleUrls: ['./dynamic-form.component.scss'],
	providers: [DynamicFormPackageControlService]
})
export class DynamicFormComponent implements OnInit, OnDestroy, AfterViewInit {
	@Input() formHeight: string;
	@Input() componentData: any;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('name', { static: true }) componentName: ElementRef;
	editComponentName = false;
	duplicateName = false;
	nameLength = false;
	form: FormGroup;
	formSubscription: Subscription;
	formPackages: Array<FormPackage>;
	nameValidationSubscription;
	isAdmin;

	constructor(
		private cs: ComponentService,
		private dfpcs: DynamicFormPackageControlService,
		private fb: FormBuilder,
		private auth: AuthService,
		private cd: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();

		this.formPackages = this.isUiForm() ? this.componentData.config['ui-form'].packages.sort((a, b) => a.order - b.order) : [];

		if (this.componentData && this.componentData.config) {
			this.form = this.fb.group({
				name: this.componentData.name || 'New Custom',
				config:
					this.formPackages && this.formPackages.length
						? this.dfpcs.toFormGroup(this.formPackages, this.componentData)
						: this.fb.group({})
			});
		}

		this.formSubscription = this.form.valueChanges
			.pipe(
				tap(() => this.cs.updateDisabledSave(this.form.invalid || this.editComponentName)),
				filter((formData) => this.form.valid),
				map((formData: any) => {
					this.componentData.name = formData.name;
					this.componentData.config = Object.assign({}, this.componentData.config, formData.config);
					return this.componentData;
				}),
				tap((componentData) => this.cs.updateComponentData(componentData)),
				debounceTime(1000)
			)
			.subscribe();
	}

	ngAfterViewInit() {
		if (this.pageType == 'new' || this.pageType == 'duplicate') {
			this.setEditNameFocus();
			this.editComponentName = true;
			this.setEditNameSelect();
		}
		this.cd.detectChanges();
	}

	ngOnDestroy(): void {
		this.formSubscription.unsubscribe();
		if (this.nameValidationSubscription) {
			this.nameValidationSubscription.unsubscribe();
		}
	}

	setEditNameFocus() {
		setTimeout(() => {
			this.componentName.nativeElement.focus();
			this.cs.updateDisabledSave(true);
		}, 10);
	}

	setEditNameSelect() {
		setTimeout(() => this.componentName.nativeElement.select(), 10);
	}

	editNameCheck() {
		this.nameValidationSubscription = this.cs.validateName(this.componentData.name, this.componentID).subscribe(
			(response: CreatorFrontApi) => {
				if (response && response.status) {
					if (response.data) {
						this.form.controls['name'].setErrors(null);
						this.cs.updateDisabledSave(false);
						this.duplicateName = false;
						this.nameLength = false;
						this.cd.detectChanges();
					} else {
						this.form.controls['name'].setErrors({ invalid: true });
						this.cs.updateDisabledSave(true);
						this.duplicateName = true;
						this.nameLength = false;
						this.cd.detectChanges();
					}
				}
			},
			(err) => {
				if (err == 'name length error' || err == 'name does not exist') {
					this.cs.updateDisabledSave(true);
					this.nameLength = true;
					this.cd.detectChanges();
				}
			}
		);
	}

	isUiForm(): boolean {
		return (
			this.componentData &&
			this.componentData.hasOwnProperty('config') &&
			this.componentData.config &&
			this.componentData.config.hasOwnProperty('ui-form') &&
			this.componentData.config['ui-form'].hasOwnProperty('packages') &&
			this.componentData.config['ui-form'].packages &&
			this.componentData.config['ui-form'].packages.length
		);
	}
}
